'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _layout = require('@prisma-cms/front/lib/components/pages/layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PageLayout = function (_PrismaCmsPageLayout) {
  _inherits(PageLayout, _PrismaCmsPageLayout);

  function PageLayout() {
    _classCallCheck(this, PageLayout);

    return _possibleConstructorReturn(this, _PrismaCmsPageLayout.apply(this, arguments));
  }

  PageLayout.prototype.getPaginationParams = function getPaginationParams() {
    var first = this.props.first;
    var page = this.getPage();
    var skip = page > 1 && first > 0 ? (page - 1) * first : undefined;
    return {
      page: page,
      skip: skip,
      first: first
    };
  };

  PageLayout.prototype.getFilters = function getFilters() {
    return {};
    var uri = this.context.uri;

    var _uri$query = uri.query(true),
        page = _uri$query.page,
        filters = _objectWithoutProperties(_uri$query, ['page']); // let {
    //   status_in,
    // } = uri.query(true);
    // if(status_in && !Array.isArray(status_in)){
    //   status_in = [status_in];
    // }
    // let filters = {
    //   status_in,
    // };


    return filters;
  };

  PageLayout.prototype.setFilters = function setFilters(filters) {
    return;
    var _context = this.context,
        uri = _context.uri,
        history = _context.router.history;
    var newUri = uri.clone();
    var query = newUri.query(true);
    Object.assign(query, _extends({}, filters));
    newUri.query(query);
    history.push(newUri.toString());
  };

  PageLayout.prototype.render = function render(content) {
    return content === null ? null : _PrismaCmsPageLayout.prototype.render.call(this, _react2.default.createElement('div', {
      style: {
        padding: "20px 10px",
        maxWidth: 1260,
        margin: "0 auto"
      }
    }, content));
  };

  return PageLayout;
}(_layout2.default);

exports.default = PageLayout;
module.exports = exports['default'];